// extracted by mini-css-extract-plugin
export default {"ZeroBlock":"ZeroBlock_ZeroBlock__unJ-s"};